/** Window event raised when a team-wide on-call override is created, started, ended or cancelled (BL-043 BE-086). */
export const ONCALL_OVERRIDE_CHANGED_EVENT = 'nog:oncall-override:changed';
